export default __webpack_public_path__ + "static/media/7.cf90a4d1.jpg";